import React, { Component, Fragment } from 'react'
import { Box } from '../../styles.style'
import { ErrorMessage, getIn } from 'formik'
import { getAddressViaCep } from '../../../register/services/cep.service'
import { MuvicardService } from '../../../../services/muvicard.service'
import { UfSelect } from '../uf-select/uf-select.component'
import { maskHelper } from '../../../../helpers/mask.helper'

const DEFAULT_UF_LABEL_TEXT = 'Selecione um estado...'
class Address extends Component {
	constructor(props) {
		super(props)

		this.state = {
			shouldRenderStateAndCity: false,
			selectedStateLabel: DEFAULT_UF_LABEL_TEXT
		}
	}

	async componentDidMount() {
		const {
			setFieldValue,
			values,
			userData,
			showLoading,
			hideLoading
		} = this.props
		try {
			MuvicardService.proposalStepRegister('Endereço', 'Acesso')
			showLoading()
			let number = ''
			let complement = ''
			let street = ''
			let neighborhood = ''
			let zipCode = ''
			if (userData) {
				const { address } = userData
				if (address) {
					number = address.number
					street = address.street
					zipCode = address.zipCode
					complement = address.complement
					neighborhood = address.neighborhood
				}
			}
			let response = await getAddressViaCep(values.zipCode)
			if (response.erro) {
				this.setState({ shouldRenderStateAndCity: true })
				setFieldValue('address.city', '')
				setFieldValue('address.street', '')
				setFieldValue('address.neighborhood', '')
				setFieldValue('address.number', '')
				setFieldValue('address.complement', '')
				return
			}
			values.address.state = response.uf
			setFieldValue('address.city', response.localidade)
			setFieldValue(
				'address.street',
				values.zipCode == zipCode.replace('-', '') &&
					response.logradouro == '' &&
					street != ''
					? street
					: response.logradouro
			)
			setFieldValue(
				'address.neighborhood',
				values.zipCode == zipCode.replace('-', '') &&
					response.bairro == '' &&
					neighborhood != ''
					? neighborhood
					: response.bairro
			)
			setFieldValue('address.number', number ? number : '')
			setFieldValue('address.complement', complement ? complement : '')
		} catch (e) {
			this.setState({ shouldRenderStateAndCity: true })
			setFieldValue('address.city', '')
			setFieldValue('address.street', '')
			setFieldValue('address.neighborhood', '')
			setFieldValue('address.number', '')
			setFieldValue('address.complement', '')
		} finally {
			hideLoading()
		}
	}

	nextPage = () => {
		const { address, zipCode } = this.props.values
		const newAddress = { zipCode, ...address }
		const obj = { address: newAddress }

		MuvicardService.sendPersonalData(obj)
			.then(data => {
				if (data.success) {
					MuvicardService.proposalStepRegister('Endereço', 'Atualização')
					this.props.nextStep()
				}
			})
			.catch(e => console.warn(e.errors))
	}

	handleUfSelection = state => {
		this.props.values.address.state = state.value
		this.setState({
			selectedStateLabel: state.label
		})
	}

	render() {
		const {
			handleBlur,
			handleChange,
			prevStep,
			values,
			errors,
			touched
		} = this.props
		if (values && values.address) {
			values.address.number = maskHelper.onlyNumbers(values.address.number)
		}
		const { shouldRenderStateAndCity, selectedStateLabel } = this.state
		return (
			<Box className="box-address">
				<div className="field safari-force-centering">
					<fieldset>
						{shouldRenderStateAndCity && (
							<Fragment>
								<div className="row">
									<div className="col">
										<UfSelect
											selected={selectedStateLabel}
											handleSelection={this.handleUfSelection}
										/>
									</div>
								</div>
								<div className="row">
									<div className="col">
										<input
											autoComplete="off"
											type="text"
											placeholder="Cidade"
											name="address.city"
											value={values.address.city || ''}
											onChange={handleChange}
											onBlur={handleBlur}
											className={
												getIn(errors, 'address.city') &&
												getIn(touched, 'address.city')
													? 'field-error'
													: ''
											}
										/>
									</div>
									<ErrorMessage
										component="div"
										name="address.city"
										className="msg-error"
									/>
								</div>
							</Fragment>
						)}
						<div className="box-field">
							<div className="row">
								<div className="col">
									<input
										autoComplete="off"
										type="text"
										placeholder="Rua"
										name="address.street"
										value={values.address.street || ''}
										onBlur={handleBlur}
										onChange={handleChange}
										className={
											getIn(errors, 'address.street') &&
											getIn(touched, 'address.street')
												? 'field-error'
												: ''
										}
									/>
								</div>
								<ErrorMessage
									component="div"
									name="address.street"
									className="msg-error"
								/>
								<div className="col">
									<input
										autoComplete="off"
										type="text"
										placeholder="Bairro"
										name="address.neighborhood"
										value={values.address.neighborhood || ''}
										onChange={handleChange}
										onBlur={handleBlur}
										className={
											getIn(errors, 'address.neighborhood') &&
											getIn(touched, 'address.neighborhood')
												? 'field-error'
												: ''
										}
									/>
								</div>
								<ErrorMessage
									component="div"
									name="address.neighborhood"
									className="msg-error"
								/>
							</div>
						</div>

						<div className="box-field">
							<div className="col">
								<input
									autoComplete="off"
									type="text"
									placeholder="Número"
									name="address.number"
									value={values.address.number || ''}
									onBlur={handleBlur}
									onChange={handleChange}
									className={
										getIn(errors, 'address.number') &&
										getIn(touched, 'address.number')
											? 'field-error numero'
											: 'numero'
									}
								/>
								<ErrorMessage
									component="div"
									name="address.number"
									className="msg-error"
								/>
							</div>

							<div className="col">
								<input
									autoComplete="off"
									type="text"
									placeholder="Complemento"
									name="address.complement"
									id="complement"
									value={values.address.complement || ''}
									onBlur={handleBlur}
									onChange={handleChange}
									className={
										getIn(errors, 'address.complement') &&
										getIn(touched, 'address.complement')
											? 'field-error'
											: ''
									}
								/>
								<ErrorMessage
									component="div"
									name="address.complement"
									className="msg-error"
								/>
							</div>
						</div>
						{values.address.number == '' ? (
							<small className="hide">
								* Preencher os campos em branco.
							</small>
						) : null}
					</fieldset>
				</div>

				<footer className="footer">
					<button
						className="button transparent"
						type="button"
						onClick={() => prevStep()}>
						Voltar
					</button>
					<button
						disabled={
							!values.address.street ||
							!values.address.neighborhood ||
							!values.address.number ||
							(values.address.number && values.address.number < 1) ||
							(shouldRenderStateAndCity &&
								(!values.address.state || !values.address.city))
						}
						className="button"
						type="button"
						onClick={() => this.nextPage()}>
						Próximo
					</button>
				</footer>
			</Box>
		)
	}
}

export default Address
